import { dialogDefault, DIALOG_APPOINTMENT } from "../consts";

const mydialog = {...dialogDefault, editable: true}

export const dialogAppointmentAction = info => ({
    type: DIALOG_APPOINTMENT,
    payload: info
});

export default function clienteDialogReducer(state = mydialog, { type, payload }) {
    const actions = {
        [DIALOG_APPOINTMENT] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}